import { ShieldOff } from "lucide-react";
import { useReportAccessDenied } from "@/components/RouteAccessContext";

interface AccessDeniedProps {
  /**
   * O que a pessoa tentou abrir, JÁ COM A PREPOSIÇÃO CONTRAÍDA: "ao Painel",
   * "à Agenda de Coletas", "ao Financeiro". A contração depende do gênero da
   * palavra, então quem chama escreve a forma certa — montar aqui produziria
   * "acesso a o Painel".
   *
   * Sem isso a mensagem vira genérica e o suporte recebe "deu acesso negado"
   * sem saber onde.
   */
  area?: string;
}

/**
 * Acesso negado por falta de permissão — GR-637.
 *
 * Renderiza DENTRO do Layout, no lugar do conteúdo da rota: o menu e o header
 * continuam de pé, então a pessoa tem para onde ir. A tela cheia de
 * `src/pages/Unauthorized.tsx` continua existindo para o caso de bloqueio
 * fora do shell.
 *
 * O texto atribui a negativa ao PERFIL DE ACESSO, não a uma falha nem a
 * ausência de dado. É a distinção que o épico GR-561 pede ("telas sem dado e
 * telas sem permissão passam a exibir mensagens distintas"): estado vazio
 * redigido como erro manda o usuário abrir chamado à toa.
 */
export const AccessDenied = ({ area }: AccessDeniedProps) => {
  // Avisa o shell para ele não disparar por cima da negativa o que dispara
  // por rota — hoje a pesquisa de CSAT.
  useReportAccessDenied();

  return (
  <div
    role="status"
    className="flex min-h-[60vh] flex-col items-center justify-center px-6 text-center"
  >
    <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-neutral-100">
      <ShieldOff className="h-6 w-6 text-muted-foreground" aria-hidden="true" />
    </div>
    <h1 className="text-lg font-semibold text-foreground">
      Você não tem acesso {area ?? "a esta tela"}
    </h1>
    <p className="mt-2 max-w-md text-sm text-muted-foreground">
      Seu perfil de acesso não inclui esta área. Peça a quem administra os
      usuários da sua empresa para liberar.
    </p>
  </div>
  );
};

export default AccessDenied;
